<template>
    <strong v-if="isDoctor && windowWidth <= 767" class="admin__m-msg r-strong">
        Пожалуйста, посетите веб-сайт со своего настольного компьютера, чтобы отредактировать расписание
    </strong>

    <section class="profile__section" v-else>
        <h2 class="profile__subtitle">Расписание</h2>
        <div class="profile__calendar">
            <div class="calendar">
                <calendar-time-message></calendar-time-message>
                <div class="calendar__header" v-if="userTimeZoneName">
                    <strong class="calendar__msg r-strong">Расписание формируется на основе Вашего часового пояса: {{ userTimeZoneName + ' (' + userTimeZoneOffset + ')' }}</strong>
                </div>
                <div class="calendar__header" v-else>
                    <strong class="calendar__msg r-strong">Расписание формируется на основе Вашего часового пояса: {{ notAuthTimeZone + ' (UTC+' + notAuthOffset + ')' }}</strong>
                </div>
                <div :class="{ 'admin__v-schedule' : isDoctor }" class="v-schedule">
                    <schedule-panel v-if="access === 'doctor'"></schedule-panel>
                    <schedule-log-in-message v-if="!user && windowWidth > 767"></schedule-log-in-message>
                    <schedule-change-message></schedule-change-message>
                    <calendar></calendar>
                    <schedule-log-in-message v-if="!user && windowWidth <= 767"></schedule-log-in-message>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import {mapState, mapGetters, mapMutations} from 'vuex';
    import {store} from "./shedule-store";

    import Calendar from "./calendar/Calendar.vue";
    import SchedulePanel from "./SchedulePanel.vue";
    import ScheduleChangeMessage from "./ScheduleChangeMessage.vue";
    import ScheduleLogInMessage from "./ScheduleLogInMessage.vue";
    import CalendarTimeMessage from "./calendar/CalendarTimeMessage";

    export default {
        name: 'Schedule',
        store,
        components: {
            ScheduleChangeMessage,
            SchedulePanel,
            Calendar,
            ScheduleLogInMessage,
            CalendarTimeMessage
        },
        data: () => ({
            user: window.laravel.user,
            isDoctor: false,
        }),
        mounted() {
            if (this.user && this.access.indexOf('doctor') + 1) {
                this.isDoctor = true;
            }
        },
        computed: {
            ...mapState([
                'access',
                'windowWidth',
                'userTimeZoneOffset',
                'userTimeZoneName'
            ]),
            notAuthTimeZone() {
                return Intl.DateTimeFormat().resolvedOptions().timeZone;
            },
            notAuthOffset() {
                return -new Date().getTimezoneOffset()/60;
            }
        }
    }
</script>

